import css from './app.css?inline'
import Checkout from './Checkout.svelte'
import {mount} from 'svelte';
import {query as gqlQuery} from './lib/graphqlClient.js';
import {addItem, deleteItem, store as basketStore} from './lib/basketStore.svelte.js';
import {logout, saveUser, store as userStore} from './lib/userStore.svelte.js';
import {fetchShippingAndPayment, paymentStore} from './lib/paymentStore.svelte.js';
import {sessionStore, checkSession, markExpectedAlive, resetSession} from './lib/sessionStore.svelte.js';

// Facade für den separaten Debug-Bundle (src/debug.js). Prod-Build emittiert
// debug.js mit eigener Svelte-Runtime; rune-State teilt sich NICHT über
// Bundle-Grenzen. Debug-Panel liest deshalb store-Daten + Actions via window.
if (typeof window !== 'undefined') {
    window.__m7Checkout = {
        addItem, deleteItem, logout, basketStore, userStore,
        saveUser, fetchShippingAndPayment, gqlQuery, paymentStore,
        // Exposed for the F32 expiry test (test_f32_session_expired.sh):
        // lets the script trigger a fresh probe + read the resulting state
        // without depending on visibilitychange-event plumbing.
        sessionStore, checkSession, markExpectedAlive, resetSession,
    };
}

// window.deliveryInfo is normally seeded by legacy ys_top_banner_delivery.tpl
// in the OXID page wrapper. The Svelte checkout dev server bypasses that
// layout, so we pull the same payload via the oxid-proxy GraphQL endpoint and
// expose it on window. Fire-and-forget — ShippingMethodCard polls every 1s and
// will pick it up as soon as it lands. Skips refetch if already set (e.g. when
// the prod-mode tpl ran first).
if (typeof window !== 'undefined' && !window.deliveryInfo) {
    gqlQuery('{ deliveryInfo { types holidays transitHolidays m7Days debug } }')
        .then(data => {
            if (data?.deliveryInfo) window.deliveryInfo = data.deliveryInfo;
        })
        .catch(() => {});
}

if (import.meta.env.DEV) {
    import('./app.css');
}

if (import.meta.env.DEV) {
    const sendError = (tag, data) => {
        const params = new URLSearchParams({cl: 'm7-checkout-dpc', fnc: 'frontendLog'});
        fetch(`/index.php?${params}`, {
            method: 'POST',
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({tag, data}),
        }).catch(() => {});
    };

    window.addEventListener('error', (event) => {
        sendError('js-error', {
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            stack: event.error?.stack ?? null,
        });
        // don't suppress — let browser still log it
    });

    window.addEventListener('unhandledrejection', (event) => {
        const err = event.reason;
        sendError('js-unhandledrejection', {
            message: err?.message ?? String(err),
            stack: err?.stack ?? null,
        });
    });
}

const TAG_NAME = 'm7-checkout';

const STYLE_ID = 'm7-checkout-styles';

/**
 * decision: [1]
 */
function injectStyles() {
    if (!import.meta.env.PROD) return;
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
}

class M7Checkout extends HTMLElement {
    _app = null;

    connectedCallback() {
        injectStyles();

        this._app = mount(Checkout, {target: this});
    }
}

// Guard gegen Doppel-Registrierung: Bei A/B-Testing wird das checkout-Bundle
// gelegentlich zweimal vom Smarty-Layout geladen → das zweite define() failt
// mit NotSupportedError, das erste Mount läuft mit unvollständigem
// paymentStore weiter (Express-Buttons-Skeleton bleibt stehen). Idempotent:
// wenn die Definition schon da ist, lassen wir die bestehende stehen.
if (!customElements.get(TAG_NAME)) {
    customElements.define(TAG_NAME, M7Checkout);
}
